__turbopack_context__.v({
  "container": "linkset-module-scss-module__ySsrOW__container",
  "darkBackground": "linkset-module-scss-module__ySsrOW__darkBackground",
  "darkTheme": "linkset-module-scss-module__ySsrOW__darkTheme",
  "linkSet": "linkset-module-scss-module__ySsrOW__linkSet",
  "row": "linkset-module-scss-module__ySsrOW__row",
  "smallLinkSet": "linkset-module-scss-module__ySsrOW__smallLinkSet",
  "smallSpan": "linkset-module-scss-module__ySsrOW__smallSpan",
});
